<template>
  <b-container fluid>
    <!-- Search Form -->
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title">{{ $t('globalTrans.dashboard')}}</h4>
      </template>
      <template v-slot:body>
        <b-row>
          <b-col xl="4" lg="4" md="4" sm="12" xs="12" rules="required|min_value:1">
            <b-form-group
            class="row"
            label-cols-sm="4"
            :label="$t('globalTrans.year')"
            label-for="fiscal_year"
            >
              <b-form-select
                plain
                v-model="search.fiscal_year"
                :options="fiscalYearList"
                id="fiscal_year"
                >
                <template v-slot:first>
                <b-form-select-option :value="0" >{{$t('globalTrans.select')}}</b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col xl="4" lg="4" md="4" sm="12" xs="12" rules="required|min_value:1">
            <b-form-group
            class="row"
            label-cols-sm="4"
            :label="$t('globalTrans.month')"
            label-for="month_id"
            >
              <b-form-select
                plain
                v-model="search.month_id"
                :options="monthList"
                id="month_id"
                >
                <template v-slot:first>
                <b-form-select-option :value="0" >{{$t('globalTrans.select')}}</b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col xl="4" lg="4" md="4" sm="12" xs="12" rules="required|min_value:1">
            <b-form-group
            class="row"
            label-cols-sm="4"
            :label="$t('grant_config.service_type')"
            label-for="service_type_list"
            >
              <b-form-select
                plain
                v-model="search.service_type_id"
                :options="serviceTypeList"
                id="service_type_list"
                >
                <template v-slot:first>
                <b-form-select-option :value="0" >{{$t('globalTrans.select')}}</b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col xl="4" lg="4" md="4" sm="12" xs="12">
              <b-form-group
              class="row"
              label-cols-sm="4"
              :label="$t('grant_config.service_name')"
              label-for="service_list"
              >
                <b-form-select
                  plain
                  v-model="search.service_name_id"
                  :options="serviceNameList"
                  id="service_list"
                  >
                  <template v-slot:first>
                  <b-form-select-option :value="0" >{{$t('globalTrans.select')}}</b-form-select-option>
                  </template>
                </b-form-select>
              </b-form-group>
          </b-col>
          <b-col xl="4" lg="4" md="4" sm="12" xs="12">
            <b-form-group
                class="row"
                label-cols-sm="4"
                label-for="division_id"
                >
                <template v-slot:label>
                {{ $t('org_pro_division.division')}}
                </template>
                <b-form-select
                plain
                v-model="search.division_id"
                :options="divisionList"
                id="division_id"
                >
                <template v-slot:first>
                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                </template>
                </b-form-select>
            </b-form-group>
          </b-col>
          <b-col xl="4" lg="4" md="4" sm="12" xs="12">
            <b-form-group
                class="row"
                label-cols-sm="4"
                label-for="district_id"
                >
                <template v-slot:label>
                {{ $t('org_pro_district.district')}}
                </template>
                <b-form-select
                plain
                v-model="search.district_id"
                :options="districtList"
                id="district_id"
                >
                <template v-slot:first>
                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                </template>
                </b-form-select>
            </b-form-group>
          </b-col>
          <b-col xl="4" lg="4" md="4" sm="12" xs="12">
            <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search')}}</b-button>
          </b-col>
        </b-row>
      </template>
    </iq-card>
    <b-row>
      <b-col md="4" sm="4" class="custom-box-shadow">
        <b-overlay :show="loadingState">
          <div class="bg-primary p-3 rounded mb-3 text-center">
              <h5 class="text-white d-block">
                  {{ $t('socialWelfareMcm.totalComplain')}}
              </h5>
              <b-spinner v-if="unitLoad" variant="primary" label="Spinning"></b-spinner>
              <h2 v-else class="text-white">{{ $n(data.totalComplain ? data.totalComplain : '0') }}<span class="ml-5"></span></h2>
          </div>
        </b-overlay>
      </b-col>
      <b-col md="4" sm="4" class="custom-box-shadow">
        <b-overlay :show="loadingState">
          <div class="bg-primary p-3 rounded mb-3 text-center">
              <h5 class="text-white d-block">
                  {{ $t('socialWelfareMcm.totalCommitee')}}
              </h5>
              <b-spinner v-if="unitLoad" variant="primary" label="Spinning"></b-spinner>
              <h2 v-else class="text-white">{{ $n(data.totalCommitee ? data.totalCommitee : '0') }}<span class="ml-5"></span></h2>
          </div>
        </b-overlay>
      </b-col>
      <b-col md="4" sm="4" class="custom-box-shadow">
        <b-overlay :show="loadingState">
          <div class="bg-primary p-3 rounded mb-3 text-center">
              <h5 class="text-white d-block">
                  {{ $t('socialWelfareMcm.totalManual')}}
              </h5>
              <b-spinner v-if="unitLoad" variant="primary" label="Spinning"></b-spinner>
              <h2 v-else class="text-white">{{ $n(data.totalManual ? data.totalManual : '0') }}<span class="ml-5"></span></h2>
          </div>
        </b-overlay>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import RestApi, { socialWelfareServiceBaseUrl } from '@/config/api_config'
import { manualDashboardApi, servicePointChangeStatusApi } from '../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'

export default {
  mixins: [ModalBaseMasterList],
  components: {
  },
  data () {
    return {
       search: {
        fiscal_year: 0,
        month_id: 0,
        service_type_id: 0,
        service_name_id: 0,
        division_id: 0,
        district_id: 0
      },
      districtList: [],
      serviceNameList: [],
      url: socialWelfareServiceBaseUrl,
      data: [],
      rows: []
    }
  },
  computed: {
    fiscalYearList: function () {
        const objectData = this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
        return objectData.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.text_en, text: obj.text_bn }
            } else {
                return { value: obj.text_en, text: obj.text_en }
            }
        })
    },
    monthList: function () {
        const objectData = this.$store.state.commonObj.monthList
        return objectData.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    serviceTypeList: function () {
        const objectData = this.$store.state.SocialWelfareService.commonObj.serviceTypeList.filter(item => item.status === 1)
        return objectData.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    divisionList: function () {
        const divisionList = this.$store.state.commonObj.divisionList.filter(item => item.status === 0)
        return divisionList.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    formTitle () {
      return (this.editItemId === 0) ? this.$t('socialWelfareMcm.servicePoint') + ' ' + this.$t('globalTrans.entry') : this.$t('socialWelfareMcm.servicePoint') + ' ' + this.$t('grant_config.modify')
    },
    ViewTitle () {
       return (this.$t('socialWelfareMcm.servicePoint') + ' ' + this.$t('globalTrans.view'))
    },
    currentLocale () {
      return this.$i18n.locale
    },
    columns () {
      const labels = [
          { label: this.$t('globalTrans.sl_no'), class: 'text-center' },
          { label: this.$t('socialWelfareMcm.serviceName'), class: 'text-center' },
          { label: this.$t('socialWelfareMcm.servicePointName'), class: 'text-center' },
          { label: this.$t('socialWelfareMcm.areaType'), class: 'text-center' },
          { label: this.$t('socialWelfareMcm.address'), class: 'text-center' },
          { label: this.$t('globalTrans.status'), class: 'text-center' },
          { label: this.$t('globalTrans.action'), class: 'text-center w-15' }
        ]

      let keys = []

      if (this.$i18n.locale === 'bn') {
        keys = [
          { key: 'index' },
          { key: 'service_name_id' },
          { key: 'service_point_name_bn' },
          { key: 'area_type_id' },
          { key: 'address' },
          { key: 'status' },
          { key: 'action' }
        ]
      } else {
        keys = [
          { key: 'index' },
          { key: 'service_name_id' },
          { key: 'service_point_name' },
          { key: 'area_type_id' },
          { key: 'address' },
          { key: 'status' },
          { key: 'action' }
        ]
      }
      return labels.map((item, index) => {
          return Object.assign(item, keys[index])
        })
    }
  },
  watch: {
    'search.service_type_id': function () {
        this.serviceNameList = this.serviceName()
    },
    '$i18n.locale': function (newValue) {
        this.serviceNameList = this.getService()
    },
    'search.division_id': function (newVal, oldVal) {
        this.districtList = this.getDistrictList(newVal)
    }
  },
  created () {
    this.serviceNameList = this.getService()
    if (this.id) {
        const tmp = this.getRoutineData()
        this.dataArray = tmp
    }
    this.loadData()
  },
  mounted () {
  },
  methods: {
    searchData () {
      this.loadData()
    },
    edit (item) {
      this.editItemId = item.id
    },
    view (item) {
      this.editItemId = item.id
    },
    remove (item) {
      this.changeStatus(socialWelfareServiceBaseUrl, servicePointChangeStatusApi, item)
    },
    loadData () {
      const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      RestApi.getData(socialWelfareServiceBaseUrl, manualDashboardApi, params).then(response => {
          if (response.success) {
            this.$store.dispatch('setList', response.data.data)
              if (response.success) {
                  this.data = response.data
                  this.unitLoad = false
              }
          }
          this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
      })
    },
    getServiceName (serviceNameId) {
      const objectData = this.$store.state.SocialWelfareService.commonObj.serviceNameList.find(item => item.status === 1 && item.value === serviceNameId)
      if (objectData) {
        if (this.$i18n.locale === 'bn') {
            return objectData.text_bn
        } else {
            return objectData.text_en
        }
      } else {
        return ''
      }
    },
    getService () {
        const objectData = this.$store.state.SocialWelfareService.commonObj.serviceNameList.filter(item => item.status === 1)
        return objectData.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    serviceName () {
        const objectData = this.$store.state.SocialWelfareService.commonObj.serviceNameList.filter(item => item.status === 1 && item.service_type_id === this.search.service_type_id)
        return objectData.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    getDistrictList (divisionId = null) {
        const districtList = this.$store.state.commonObj.districtList.filter(item => item.status === 0)
        if (divisionId) {
            const district = districtList.filter(district => district.division_id === divisionId)
            return district.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        }
        return districtList.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    }
  }
}
</script>
